<div class="mbs-page"
     [ngClass]="pageClass">
  <div class="mbs-page_content"
       [ngClass]="contentClass">
    <ng-container *ngIf="!showErrorPage; else error">
      <page-header (sizeChanged)="setHeaderSize($event)">
        <ng-content select="[fixed-header]"></ng-content>
      </page-header>
      <div [headerSize]="headerSize"
           class="d-flex align-items-scretch flex-column flex-grow-1"
           straightPageContent>
        <ng-content select="[content]"></ng-content>
      </div>
    </ng-container>
    <ng-template #error>
      <page-header></page-header>
      <div class="d-flex flex-column flex-grow-1 align-items-center justify-content-center">
        <mbs-something-went-wrong (refresh)="refresh.emit()"></mbs-something-went-wrong>
      </div>
    </ng-template>
  </div>
  <ng-content select="[footer]"></ng-content>
</div>
